module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-ira001sp.1331b8af.png";